export default "__VITE_ASSET__8Piji_rP__"